module.exports = __webpack_public_path__ + "img/file-person.17e9f007.svg";